<template>
  <div id="instructions">
    <h6 class="mt-2 text-center green-header">
      {{ t("PAYMENTINFOBELOW") }}
    </h6>
    <div class="d-flex justify-content-between" v-if="!storeIsInformativeOnly">
      <p class="m-0">{{ t("DUEDATE") }}:</p>
      <p class="m-0">
        {{
          new Date(paymentInfo.paymentExpirationWindow * 1000).toLocaleString()
        }}
      </p>
    </div>
    <hr class="dashed-break" />
    <div class="d-flex justify-content-between">
      <p class="m-0">{{ t("AMOUNT") }}:</p>
      <p class="m-0">{{ currencyFormat(paying) }}</p>
    </div>
    <div id="payment-data-card" v-if="!storeIsInformativeOnly">
      <div v-if="selectedStore === PaymentMethod.oxxo">
        <p class="m-0 text-center">
          <span class="fw-bold"> {{ t("OXXOREFERENCE") }}:</span>
        </p>
        <hr class="dashed-break" />
        <p class="mt-2 mb-2 text-center">
          <span class="fw-bold">{{ paymentInfo.paymentReferenceNumber }}</span>
        </p>
      </div>
      <div v-if="selectedStore === PaymentMethod.spei">
        <p class="m-0">
          {{ t("CLABE") }}:
          <span class="fw-bold">{{
            paymentInfo.bankingPaymentReference.clabe
          }}</span>
        </p>
        <hr class="dashed-break" />
        <p class="mt-2 mb-2">
          {{ t("BANK") }}:
          <span class="fw-bold">{{
            paymentInfo.bankingPaymentReference.bankName
          }}</span>
        </p>
        <hr class="dashed-break" />
        <p class="mt-2 mb-2">
          {{ t("BENEFICIARY") }}:
          <span class="fw-bold">Payjoy</span>
        </p>
      </div>
      <div v-if="selectedStore === PaymentMethod.store">
        <p class="m-0">
          {{ t("BARCODE") }}:
          <img
            alt="barcode"
            :src="paymentInfo.barcodeUrl"
            class="mx-auto d-block"
          />
        </p>
        <hr class="dashed-break" />
        <p class="mt-2 mb-2">
          {{ t("REFERENCECODE") }}:
          <span class="fw-bold">{{ paymentInfo.paymentReferenceNumber }}</span>
        </p>
      </div>
      <div v-if="selectedStore === PaymentMethod.codi">
        <p class="m-0">
          {{ t("REQUESTSENTTO") }}:
          <span class="fw-bold">{{ paymentInfo.payerPhoneNumber }}</span>
        </p>
        <hr class="dashed-break" />
        <p class="mt-2 mb-2">
          {{ t("RECEPTOR") }}:
          <span class="fw-bold">PayJoy</span>
        </p>
        <p class="mb-1">
          {{ t("CONCEPT") }}:
          <span class="fw-bold">Payment</span>
        </p>
      </div>
    </div>
    <div v-if="shouldShowDisclaimerMessage()">
      <p class="mt-2 mb-2 text-danger">
        {{ t("PAYMENT_DISCLAIMER_MESSAGE") }}
      </p>
    </div>
    <button class="done-btn" @click="confirmPaymentBtn">
      {{ t("DONE") }}
    </button>
    <h4 class="mt-4">{{ t("INSTRUCTIONS") }}</h4>
    <MxInstructions v-if="country === CL_COUNTRY.MX" />
    <CoInstructions v-if="country === CL_COUNTRY.CO" />
    <p @click="openWhatsApp">
      {{
        t("PLEASECALLIFQUESTIONS", {
          PHONE_NUMBER: whatsappNumber,
        })
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { PaymentMethod } from "@/apps/credit-line/types/payment";
import MxInstructions from "@/apps/credit-line/components/Payments/MxInstructions.vue";
import CoInstructions from "@/apps/credit-line/components/Payments/CoInstructions.vue";
import { CL_COUNTRY } from "@/apps/credit-line/types/cl_countries";

const { t } = useI18n();
const storeIsInformativeOnly = inject("storeIsInformativeOnly");
const selectedStore = inject("selectedStore");
const confirmPaymentBtn = inject("confirmPaymentBtn");
const whatsappNumber = inject("whatsappNumber");
const openWhatsApp = inject("openWhatsApp");
const paymentInfo = inject("paymentInfo");
const currencyFormat = inject("currencyFormat");
const paying = inject("paying");
const country = inject("country");
const showDisclaimerMessage = inject("showDisclaimerMessage");

const shouldShowDisclaimerMessage = () => {
  return (
    showDisclaimerMessage &&
    (country.value === CL_COUNTRY.CO ||
      selectedStore.value === PaymentMethod.spei)
  );
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.done-btn {
  background-color: $pj-color-white;
  color: $pj-color-green;
  width: 100%;
  font-weight: bold;
  height: 50px;
  margin-top: 5%;
  border: 0.75px solid $pj-color-green;
  box-sizing: border-box;
  border-radius: 11px;
}

.color-green {
  color: $pj-color-green;
}

.dashed-break {
  border: none;
  border-top: 1.8px dashed $pj-color-black;
  color: $pj-color-white;
  background-color: $pj-color-white;
  margin-top: 2.5%;
  margin-bottom: 2.5%;
}

#payment-data-card {
  margin-top: 5%;
  padding: 5%;
  background-color: $pj-color-green-hover;
  border-radius: 10px;
}

.instructions-element {
  margin-top: 1%;
}
</style>
